import { Box, Paragraph } from '@zillow/constellation-10';
import {
  autoResponseChatBubbleStyles,
  chatBubbleStyles,
  defaultChatBubbleStyles,
  messageOwnerChatBubbleStyles,
} from './styles';

export type ChatBubbleProps = {
  children: React.ReactNode;
  onImpact?: boolean;
  senderName?: string;
  shouldIncludeGutter?: boolean;
  variant: 'autoResponse' | 'messageOwner' | 'default';
};

export const CHAT_BUBBLE_VARIANT_STYLES = {
  default: defaultChatBubbleStyles,
  autoResponse: autoResponseChatBubbleStyles,
  messageOwner: messageOwnerChatBubbleStyles,
};

export default function ChatBubble({
  children,
  onImpact = false,
  senderName,
  shouldIncludeGutter = false,
  variant,
}: ChatBubbleProps) {
  const variantStyles = CHAT_BUBBLE_VARIANT_STYLES[variant];
  const isMessageOwner = variant === 'messageOwner';
  const shouldDisplaySenderName = (!!senderName && variant === 'default') || isMessageOwner;
  const senderNameText = isMessageOwner ? 'You' : senderName;
  const textColor = onImpact && isMessageOwner ? 'white' : 'text.neutral';

  return (
    <Box
      data-testid="chat-bubble"
      css={{
        ...chatBubbleStyles,
        ...variantStyles,
        ...(shouldIncludeGutter && {
          marginLeft: isMessageOwner ? 'layout.looser' : '0',
          marginRight: isMessageOwner ? '0' : 'layout.looser',
        }),
      }}
    >
      {shouldDisplaySenderName && (
        <Paragraph
          textStyle="body-bold"
          css={{ color: textColor, marginBottom: 'tighter', textTransform: 'capitalize' }}
        >
          {senderNameText}
        </Paragraph>
      )}
      <Paragraph css={{ color: textColor, wordBreak: 'break-word' }}>{children}</Paragraph>
    </Box>
  );
}
